import * as React from 'react';
import classNames from 'classnames';
import loadSprite from './loadSprite';
var Icon = function (_a) {
    var _b = _a.prefixCls, prefixCls = _b === void 0 ? 'pptmui-icon' : _b, className = _a.className, _c = _a.size, size = _c === void 0 ? 'md' : _c, name = _a.name;
    React.useEffect(function () {
        loadSprite();
    }, []);
    var wrapperCls = classNames(prefixCls, className, prefixCls + "-" + size);
    return (React.createElement("svg", { className: wrapperCls },
        React.createElement("use", { xlinkHref: "#" + name })));
};
export default Icon;
